import { FileService } from "../../../../../../../../../../core/services/FileService";

export const CardGrid = ({ list, onClick, selectedLeaf }) => {
    if (!Array.isArray(list) || list.length === 0) return null;
    const fileService = new FileService();
    return (
        <div className="row g-3">
            {list.map((item: any) => {
                const data =
                    item.DataBeanProperties ||
                    item.EnvolvedObject?.DataBeanProperties ||
                    item;

                const iconUrl = data.Media
                    ? fileService.getUrlFile(data.MediaContext, data.Media)
                    : null;

                return (
                    <div key={data.IDLn} className="col-6 col-md-4 col-lg-3 d-flex">
                        <div
                            className={`service-card flex-fill ${data.IDLn === selectedLeaf ? "service-card-leaf" : ""}`}
                            onClick={() => onClick(data)}
                        >

                            {(data.ChildrenCount ?? 0) > 0 && (
                                <span className="service-card-badge">
                                    {data.ChildrenCount}
                                </span>
                            )}

                            {iconUrl && (
                                <img
                                    src={iconUrl}
                                    alt={data.Name}
                                    className="service-card-image"
                                />
                            )}

                            <div className="service-card-content">
                                <h6 className="service-card-title">{data.Name}</h6>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};